import { useContext } from 'react'
import Toggle from 'ui/src/components/controls/toggle'
import { EditPanelFieldComponentProps } from '..'
import { CONTROL_SIZE_SLIM } from '../../constants'
import { EditPanelFieldContext } from '../../contexts/field'
import { EditPanelContext } from '../../contexts/panel'
import { valueKeyFromField } from '../../utilities/field'
import { sharedValueFromGifs } from '../../utilities/gifs'
import { hasFieldPermission } from '../../utilities/permissions'

export default ({ className, field, gifId, size = CONTROL_SIZE_SLIM }: EditPanelFieldComponentProps) => {
    const { colors, gifs, permissions } = useContext(EditPanelContext)
    const { changeField } = useContext(EditPanelFieldContext)
    const key = valueKeyFromField(field)
    const value = sharedValueFromGifs<boolean>(gifs, key, gifId) || false

    function onIndexedChange(isIndexed: boolean) {
        changeField(field, isIndexed)
    }

    return (
        <Toggle
            backgroundColor="transparent"
            className={className}
            colorOff={colors.text}
            colorOn={colors.text}
            disabled={!hasFieldPermission('indexed', permissions)}
            isOn={value}
            labelOff="No"
            labelOn="Yes"
            size={size}
            onChange={onIndexedChange}
        />
    )
}
